const question3 = {
    'question': 'Czy na pierwszą konsultację przyjść razem czy oddzielnie?',
    'answer': 'Już od pierwszej konsultacji partnerzy przychodzą razem na spotkanie. Cechą terapii par jest to, że pacjentem nie jest jedna osoba lecz para. Terapeuta od początku skupia się na obserwacji związku, jego mocnych i słabych stron. Pozwol to terapeucie poznać Was jako zespół i zrozumieć, jak funkcjonuje Wasz związek.',
}

export default question3;